import React from 'react';
import PropTypes from 'prop-types';

import { Svg } from './styled';

export const Star = ({ filled }) => (
  <Svg
    viewBox="0 0 37 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    filled={filled}
  >
    <path
      d="M18.928.74a.5.5 0 00-.856 0L12.4 10.106l-10.658 2.5a.5.5 0 00-.264.814l7.153 8.288-.915 10.909a.5.5 0 00.691.503L18.5 28.877l10.093 4.242a.5.5 0 00.692-.503l-.916-10.91 7.153-8.287a.5.5 0 00-.264-.814l-10.658-2.5L18.928.74z"
      stroke="#fa7814"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

Star.propTypes = {
  filled: PropTypes.bool,
};
Star.defaultProps = {
  filled: false,
};
